export function formatDisplayName(defaultstring, options = {}) {
  // Default options
  const {
    maxLength = 30,
    useFirstWordAndInitials = false,
    showInitialsOnTruncate = false,
    ellipsis = '...',
    truncateAtSpace = false,
  } = options;

  // Handle edge cases
  if (!defaultstring || typeof defaultstring !== 'string') {
    return 'Anonymous';
  }

  // Trim and clean the name
  const cleanedName = defaultstring.trim().replace(/\s+/g, ' ');

  // Split name into parts
  const nameParts = cleanedName.split(' ').filter(part => part.length > 0);

  // Handle formatting with first word + initials
  if (useFirstWordAndInitials && nameParts.length > 1) {
    const firstWord = nameParts[0];
    const initials = nameParts
      .slice(1)
      .map(part => part[0].toUpperCase())
      .join('');
    const formattedName = `${firstWord}${initials}`;

    // If within maxLength, return formatted name
    if (formattedName.length <= maxLength) {
      return formattedName;
    }

    // Truncate if needed
    return formattedName.slice(0, maxLength - ellipsis.length) + ellipsis;
  }

  // If name is within maxLength, return as is
  if (cleanedName.length <= maxLength) {
    return cleanedName;
  }

  // If showing initials when truncated
  if (showInitialsOnTruncate) {
    const initials = nameParts
      .map(part => part[0].toUpperCase())
      .join('');

    // Return initials if they're short enough, otherwise truncate
    if (initials.length <= maxLength) {
      return initials;
    }
  }

  // Truncate at nearest space before maxLength
  if (truncateAtSpace) {
    let truncated = cleanedName.slice(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(' ');

    // If a space is found and it's not the last character, truncate there
    if (lastSpaceIndex > 0 && lastSpaceIndex < truncated.length - 1) {
      truncated = truncated.slice(0, lastSpaceIndex);
    }

    return truncated + ellipsis;
  }

  // Default truncation
  return cleanedName.slice(0, maxLength - ellipsis.length) + ellipsis;
}